<div>
  <div>
    <header>
      <h4>Push to your API</h4>
    </header>

    <div class="row">
      <div class="col-md-8">
        <select class="form-control" [(ngModel)]="apiSelected" (change)="apiSelectionChanged()">
          @for (api of apis | keyvalue; track api) {
            <option [value]="api.key">
              {{ api.value.title }}
            </option>
          }
        </select>
      </div>
      <div class="col-md-2">
        <button (click)="newAPIClick()" class="btn btn-primary btn-block">New API</button>
      </div>
    </div>

    @if (api) {
      <div>
        <div class="tab-container">
          <div class="tabs">
            <div [class.selected]="tabs.selected === 'api'" (click)="tabs.selected = 'api'">API</div>
            <div [class.selected]="tabs.selected === 'actions'" (click)="tabs.selected = 'actions'">Actions</div>
          </div>
          @if (tabs.selected === 'api') {
            <div class="tab api">
              <div>
                <label>Title</label>
                <input placeholder="API Title" [(ngModel)]="api.title" class="form-control" />
              </div>
              <div class="mt-1">
                <label>API Endpoint (URL)</label>
                <input placeholder="https://yourapi.io/path?ref={asset_ref}" [(ngModel)]="api.url" class="form-control" />
              </div>
              <div class="mt-1">
                <label>Payload</label>
                @if (!isEditingJSON) {
                  @if (!isEditingJSON) {
                    <pre (click)="editJSON()"><code class="language-javascript" >{{api.pretty(asset)}}</code></pre>
                  }
                }
                @if (isEditingJSON) {
                  <textarea rows="10" [(ngModel)]="api.payload" class="form-control"></textarea>
                  <button class="btn btn-sm btn-secondary" (click)="updateJSONclick()">Update</button>&nbsp;<button class="btn btn-sm btn-secondary" (click)="cancelJSONclick()">Cancel</button>
                }
              </div>
              <div class="authorisation">
                <div>Authorisation header</div>
                <div>
                  <input type="text" class="form-control" [(ngModel)]="api.authorization" />
                </div>
              </div>
              <button class="btn btn-primary btn-block mt-1" (click)="saveAPIClick()">Save API</button>
            </div>
          }
          @if (tabs.selected === 'actions') {
            <div class="tab actions">
              @if (!api.id) {
                <p>Please select or create an API first.</p>
              }
              @if (api.id) {
                <p class="api-buttons">
                  <button class="btn btn-sm btn-secondary" (click)="apiActionClick('realtime')" [class.active]="action?.action === 'realtime'" [class.in-use]="actions.get('realtime')"><i class="fa fa-fw" [class.fa-plus]="!actions.has('realtime')" [class.fa-check]="actions.has('realtime')"></i> Realtime</button>
                  <button [class.active]="action?.action === 'daily_avg'" class="btn btn-sm btn-secondary" (click)="apiActionClick('daily_avg')" [class.in-use]="actions.get('daily_avg')"><i class="fa fa-plus fa-fw" [class.fa-plus]="!actions.has('daily_avg')" [class.fa-check]="actions.has('daily_avg')"></i> Daily Average</button>
                  <button [class.active]="action?.action === 'daily_min'" class="btn btn-sm btn-secondary" (click)="apiActionClick('daily_min')" [class.in-use]="actions.get('daily_min')"><i class="fa fa-plus fa-fw" [class.fa-plus]="!actions.has('daily_min')" [class.fa-check]="actions.has('daily_min')"></i> Daily Minimum</button>
                  <button [class.active]="action?.action === 'daily_max'" class="btn btn-sm btn-secondary" (click)="apiActionClick('daily_max')" [class.in-use]="actions.get('daily_max')"><i class="fa fa-plus fa-fw" [class.fa-plus]="!actions.has('daily_max')" [class.fa-check]="actions.has('daily_max')"></i> Daily Maximum</button>
                  <button [class.active]="action?.action === 'daily_count'" class="btn btn-sm btn-secondary" (click)="apiActionClick('daily_count')" [class.in-use]="actions.get('daily_count')"><i class="fa fa-plus fa-fw" [class.fa-plus]="!actions.has('daily_count')" [class.fa-check]="actions.has('daily_count')"></i> Daily Count</button>
                </p>
              }
              @if (action && api.id) {
                <div class="action">
                  <div class="mt-1 payload">
                    <label>Payload Additions</label>
                    @if (!isEditingActionJSON) {
                      <pre (click)="editActionJSON()"><code class="language-javascript" >{{action.pretty(asset)}}</code></pre>
                    }
                    @if (isEditingActionJSON) {
                      <textarea rows="3" [(ngModel)]="action.payload" class="form-control"></textarea>
                      <button class="btn btn-sm btn-secondary" (click)="updateActionJSONclick()">Update</button>&nbsp;<button class="btn btn-sm btn-secondary" (click)="cancelActionJSONclick()">Cancel</button>
                    }
                  </div>
                  @if (api.id) {
                    <div>
                      <label>Activate</label>
                      <p>
                        Activating this API will push
                        @if (action.action === 'realtime') {
                          <span> the value in realtime. </span>
                        }
                        @if (action.action !== 'realtime') {
                          <span>
                            the
                            @if (action.action === 'daily_avg') {
                              <span>average</span>
                            }
                            @if (action.action === 'daily_min') {
                              <span>minimum value</span>
                            }
                            @if (action.action === 'daily_max') {
                              <span>maximum value</span>
                            }
                            @if (action.action === 'daily_count') {
                              <span>number of times the value was received</span>
                            }
                            at the end of the day.
                          </span>
                        }
                      </p>
                      <div class="row">
                        <div class="col-md-6">
                          <button class="btn btn-primary btn-block mt-1" (click)="testAction()">
                            <span class="fa fa-cloud-upload"></span> Test
                            <i>{{ action.action }}</i>
                          </button>
                        </div>
                        <div class="col-md-6">
                          <button class="btn btn-success btn-block mt-1" (click)="activateAction()">
                            Activate
                            <span
                              ><i>{{ action.action }}</i></span
                            >
                            now
                          </button>
                        </div>
                      </div>
                      @if (testResponse) {
                        <div class="test">
                          <h4>What was sent to the endpoint</h4>
                          <pre (click)="editActionJSON()"><code class="language-javascript" >{{testResponse}}</code></pre>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
